<template>
  <div id="">

  </div>
</template>

<script>
export default {
  name:"",
  data(){
    return {};
  },
  methods:{ /*方法存放*/

  },
  mounted(){ /*页面加载时调用*/

  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
.el-main {
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/userGlSon.vue